import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as MogulIcon } from '../../../../../common/svg/general/logo-mogul.svg';
import styles from '../styles.module.css';

const AUTH_STYLE = { width: '30px', height: '50px', marginBottom: '-0.8rem' };
const OPEN_STYLE = { width: '30px', height: '50px' };
const DEFAULT_STYLE = { width: '25px', height: '20px' };

const getStyles = (isOpen: boolean, isAuth: boolean) => {
  if (isAuth && isOpen) {
    return AUTH_STYLE;
  }

  return isOpen ? OPEN_STYLE : DEFAULT_STYLE;
};

interface Props {
  isOpen: boolean;
  isAuth: boolean;
}

export const Logo = ({ isAuth, isOpen }: Props) => {
  const style = getStyles(isOpen, isAuth);

  return (
    <Link
      to="/platform/dashboard"
      className={styles.logo}
      aria-label="Mogul Logo"
    >
      <MogulIcon style={style} />
    </Link>
  );
};
